import React from "react";
import Logo from "../../../assets/svg/Logo/Logo-burger-house.svg";
import Picto from "../../../assets/svg/Logo/picto-burger-house.svg";
import Icon from "../../../assets/svg/Icones/ico-bag-clickAndCollect.svg";
import Button from "../../elements/Button";

export default function Header() {
   return (
      <div className="flex justify-between items-center py-10 relative z-10">
         {/* Logo */}
         <div className="">
            <img src={Logo} alt="Logo de Burger House" className="w-64 hidden md:block" />
            <img src={Picto} alt="Logo de Burger House" className="w-10 md:hidden" />
         </div>
         <div className="flex flex-col gap-3">
            {/* Click & Collect */}
            <div className="text-secondary items-center gap-1 justify-end hidden md:flex">
               <img
                  src={Icon}
                  alt="Icon de Click N' Collect"
                  className="w-5 h-5"
               />
               <span className="font-semibold text-md">
                  Commandez votre repas en ligne
               </span>
            </div>
            {/* Boutons */}
            <div className="text-secondary flex items-center justify-end gap-2">
               <Button color="primary">Inscription</Button>
               <Button color="secondary">Connexion</Button>
            </div>
         </div>
      </div>
   );
}
